import request from '../utils/request'

// ==================== 意见反馈管理 ====================

// 获取反馈列表
export function getFeedbackList(params) {
  return request({
    url: '/client.feedback_controller/list',
    method: 'get',
    params
  })
}

// 获取反馈详情
export function getFeedbackDetail(id) {
  return request({
    url: '/client.feedback_controller/detail',
    method: 'get',
    params: { id }
  })
}

// 回复反馈
export function replyFeedback(data) {
  return request({
    url: '/client.feedback_controller/reply',
    method: 'post',
    data
  })
}

// 更新反馈状态
export function updateFeedbackStatus(data) {
  return request({
    url: '/client.feedback_controller/updateStatus',
    method: 'post',
    data
  })
}

// 删除反馈
export function deleteFeedback(id) {
  return request({
    url: '/client.feedback_controller/delete',
    method: 'post',
    data: { id }
  })
}

// 获取统计数据
export function getFeedbackStatistics() {
  return request({
    url: '/client.feedback_controller/statistics',
    method: 'get'
  })
}
